<template>
    <div class="w-full max-w-full">
        <video
            class="video-js vjs-big-play-centered inline-block"
            controls
            ref="player"
            width="640"
        >
            <source :src="src" type="video/mp4" />
        </video>
    </div>
</template>

<script>
import "video.js/dist/video-js.css";
import videojs from "video.js";

export default {
    name: "DdVideoPlayer",
    props: {
        src: {
            type: String,
            default: ""
        },
        startAt: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            player: null
        };
    },
    mounted() {
        const currentTime = this.startAt;

        this.player = videojs(this.$refs.player, {}, function() {
            this.currentTime(currentTime);
        });
    }
};
</script>